import React from "react";
import { Flex, Button, Icon } from "@chakra-ui/react";
import { MdNorthEast } from "react-icons/md";

const ActionButton = ({
  text = "See more",
  icon = MdNorthEast,
  onClick,
  containerProps = {},
  colors = {
    textColor: "#25575F",
    textBorder: "1px solid #25575F",
    textHover: "#f0f9fa",
    iconBg: "#215560",
    iconHover: "#1a3d17",
  },
}) => {
  return (
    <Flex justify="center" mt={8} gap={4} {...containerProps}>
      {/* Text part of the button */}
      <Button
        color={colors.textColor}
        border={colors.textBorder}
        _hover={{ bg: colors.textHover }}
        size="lg"
        px={8}
        borderRadius="full"
        fontWeight={"normal"}
        onClick={onClick}
      >
        {text}
      </Button>

      {/* Icon part of the button */}
      <Button
        bg={colors.iconBg}
        color="white"
        borderRadius="full"
        w="48px"
        h="48px"
        minW="48px"
        p={0}
        boxShadow="md"
        _hover={{ bg: colors.iconHover, boxShadow: "lg" }}
        transition="all 0.2s"
        display="flex"
        alignItems="center"
        justifyContent="center"
        onClick={onClick}
      >
        <Icon as={icon} boxSize={6} />
      </Button>
    </Flex>
  );
};

export default ActionButton;
